var retryIntervalsInMs = [0, 11, 22, 33];
export function getRandomRetryInterval() {
    var index = Math.floor(Math.random() * 1000) % retryIntervalsInMs.length;
    return retryIntervalsInMs[index];
}
//# sourceMappingURL=getRandomRetryInterval.js.map